import { post, get } from './Tools';

const getEmailConfig = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}email/config`);
  return response;
};

const saveEmailConfig = async (config) => {
  const response = await post(`${process.env.REACT_APP_SERVER}email/config`, config);
  return response;
};

const testEmailConfig = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}email/config/test`, payload);
  return response;
};

export { getEmailConfig, saveEmailConfig, testEmailConfig };
